import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import { Row, Column } from './styles/Row';

function TableRow(props) {
  const { title, value } = props;

  return (
    <Row>
      <Column fullWidth>
        <Typography variant="paragraph2">
          {title}
        </Typography>
      </Column>
      <Column textAlign="right">
        <Typography variant="paragraph2">
          {value}
        </Typography>
      </Column>
    </Row>
  );
}

TableRow.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default TableRow;
